import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import RootLayout from '@/layouts/RootLayout';

/**
 * Web3应用中心（游戏广场）
 */
var tinyPlanet = {
  path: '/tinyPlanet',
  component: RootLayout,
  // redirect: '/tinyPlanet',
  children: [
  // 专门兼容https://h5.ubanquan.cn/tinyPlanet?code=SWJE邀请地址，其他内部跳转全部使用新路由进行跳转
  {
    path: '/tinyPlanet',
    name: 'TinyPlanet',
    component: function component() {
      return import('views/tinyPlanet/Redirect');
    },
    meta: {
      title: 'Web3应用中心'
      // auth: true
    }
  }, {
    path: '/destroyNFR',
    name: 'DestroyNFR',
    component: function component() {
      return import('views/tinyPlanet/destroyNFR');
    },
    meta: {
      title: '熔炼NFR 增加融合能量'
    }
  }, {
    path: '/tpAgreement',
    name: 'TPAgreement',
    component: function component() {
      return import('views/tinyPlanet/tpAgreement');
    },
    meta: {
      title: '用户协议'
    }
  }, {
    path: '/destroyResult',
    name: 'DestroyResult',
    component: function component() {
      return import('views/tinyPlanet/destroyResult');
    },
    meta: {
      title: ''
    }
  }, {
    path: '/destroyRecord',
    name: 'DestroyRecord',
    component: function component() {
      return import('views/tinyPlanet/destroyRecord');
    },
    meta: {
      title: ''
    }
  }, {
    path: '/safetyVerification',
    name: 'SafetyVerification',
    component: function component() {
      return import('views/tinyPlanet/safetyVerification');
    },
    meta: {
      title: '安全验证'
    }
  }, {
    path: '/inviteFriends',
    name: 'InviteFriends',
    component: function component() {
      return import('views/tinyPlanet/inviteFriends');
    },
    meta: {
      title: '邀请好友'
    }
  }, {
    path: '/TPlottery',
    name: 'TinyPlanetLottery',
    component: function component() {
      return import('views/tinyPlanet/tinyPlanetLottery/index');
    },
    meta: {
      title: '幸运转转转'
    }
  }, {
    path: '/TPSkillCard',
    name: 'TPSkillCard',
    component: function component() {
      return import('views/tinyPlanet/tinyPlanetLottery/skillCard');
    },
    meta: {
      title: '技能卡'
    }
  }]
};
export default tinyPlanet;